import React from 'react';

const sections = [
  {
    title: '1. Alcance y Cumplimiento',
    content: (
      <p>
        Esta política se aplica estrictamente a nuestra plataforma SaaS B2B, que proporciona soluciones de CRM,
        recordatorios de citas automatizados y servicios de chatbot impulsados por IA para clínicas y
        pequeñas y medianas empresas (pymes) en América Latina. Operamos en pleno cumplimiento con
        los estándares internacionales de protección de datos y las regulaciones locales, incluyendo la
        Ley Orgánica de Protección de Datos Personales (LOPDP) de Ecuador.
      </p>
    ),
  },
  {
    title: '2. Información que Recopilamos de las API de Meta',
    content: (
      <>
        <p>
          Para proporcionar nuestros servicios principales de mensajería y gestión, cuando una empresa se autentica
          a través de Meta Login y conecta su cuenta de WhatsApp Business, Ruray Digital solicita
          acceso a datos específicos a través de los siguientes permisos:
        </p>
        <ul>
          <li>
            <strong>whatsapp_business_management:</strong> Accedemos y gestionamos los activos de la cuenta de WhatsApp Business,
            tales como plantillas de mensajes aprobadas, IDs de números de teléfono y configuraciones
            de webhooks.
          </li>
          <li>
            <strong>whatsapp_business_messaging:</strong> Procesamos los mensajes entrantes y salientes de WhatsApp,
            registros multimedia y metadatos de perfiles enviados por los usuarios finales a las líneas de
            negocio conectadas de nuestros clientes.
          </li>
        </ul>
      </>
    ),
  },
  {
    title: '3. Cómo Utilizamos los Datos de la Plataforma Meta',
    content: (
      <>
        <p>
          Cualquier dato recibido a través de las API de Meta se utiliza estrictamente para ofrecer y mejorar
          los servicios de nuestra plataforma. Específicamente, se utiliza para:
        </p>
        <ul>
          <li>Mostrar conversaciones de chat en vivo dentro de nuestra bandeja de entrada CRM centralizada.</li>
          <li>Activar alertas de transacciones y recordatorios de citas automatizados basados en las acciones del usuario.</li>
          <li>Ejecutar respuestas automatizadas a través de chatbots impulsados por IA o basados en reglas.</li>
          <li>Generar análisis de rendimiento agregados y anónimos para nuestros clientes comerciales.</li>
        </ul>
        <p className="disclosure">
          <strong>Aviso Importante:</strong> Ruray Digital no vende, alquila ni cede los Datos de la Plataforma
          Meta ni la información de los usuarios a empresas de marketing de terceros, intermediarios o
          entidades externas. Toda la utilización de datos se limita estrictamente a operaciones funcionales
          internas.
        </p>
      </>
    ),
  },
  {
    title: '4. Uso de datos de Google Calendar',
    content: (
      <>
        <p>
          Ruray Digital ofrece a las clínicas la opción de conectar su cuenta de Google Calendar para que
          las citas agendadas a través de nuestra plataforma aparezcan automáticamente en su calendario.
        </p>
        <p style={{ marginTop: '0.75rem' }}>
          <strong>Qué datos accedemos.</strong> Con tu autorización, creamos un calendario secundario dedicado
          ("Ruray Digital — Citas") dentro de tu cuenta de Google, y únicamente creamos, modificamos o eliminamos
          eventos dentro de ese calendario. No accedemos, leemos ni modificamos tu calendario personal ni ningún
          otro evento existente en tu cuenta de Google.
        </p>
        <p style={{ marginTop: '0.75rem' }}>
          <strong>Para qué lo usamos.</strong> Los eventos que creamos contienen la información básica de cada cita
          agendada por tus pacientes (fecha, hora y nombre del paciente), con el único fin de que tu clínica
          pueda visualizar su agenda directamente en la aplicación de Google Calendar que ya usa a diario.
        </p>
        <p style={{ marginTop: '0.75rem' }}>
          <strong>Cómo se almacena y comparte.</strong> Los datos de la cita permanecen almacenados en los sistemas
          de Ruray Digital y en el calendario secundario de tu propia cuenta de Google. No compartimos, vendemos ni
          transferimos estos datos a terceros bajo ninguna circunstancia.
        </p>
        <p style={{ marginTop: '0.75rem' }}>
          <strong>Cómo revocar el acceso.</strong> Puedes desconectar tu Google Calendar en cualquier momento desde
          la configuración de tu cuenta de Ruray Digital, o directamente desde los permisos de aplicaciones de terceros
          de tu cuenta de Google (myaccount.google.com/permissions). Al revocar el acceso, dejamos de crear o modificar
          eventos; el calendario secundario y sus eventos permanecen en tu cuenta de Google hasta que decidas eliminarlos
          tú mismo.
        </p>
        <p className="disclosure">
          El uso que hace Ruray Digital de la información recibida de las APIs de Google se ajusta a la Política de
          Datos de Usuario de los Servicios de API de Google (developers.google.com/terms/api-services-user-data-policy),
          incluidos los requisitos de Uso Limitado.
        </p>
      </>
    ),
  },
  {
    title: '5. Procesamiento, Almacenamiento, Retención y Seguridad de Datos',
    content: (
      <>
        <p>Implementamos estrictos protocolos de seguridad de nivel empresarial para salvaguardar toda la información procesada:</p>
        <ul>
          <li>
            <strong>Transferencia Internacional (Encargados del Tratamiento):</strong> Utilizamos infraestructura proporcionada
            por Amazon Web Services (AWS) ubicada en los Estados Unidos de América para el almacenamiento seguro en la nube y
            el alojamiento de datos. Esto constituye una transferencia internacional de datos, la cual se realiza bajo
            estándares de seguridad adecuados.
          </li>
          <li>
            <strong>Períodos de Retención:</strong> Los mensajes, conversaciones y datos de contacto se conservan por un
            período de 5 años, en alineación con las obligaciones tributarias (SRI) y operativas aplicables.
          </li>
          <li>
            <strong>Arquitectura Multi-inquilino:</strong> Todas las entradas de bases de datos, registros de usuarios y
            registros de mensajes están completamente aislados a través de silos de datos independientes dentro de AWS,
            asegurando que no haya fugas de datos entre cuentas.
          </li>
          <li>
            <strong>Cifrado:</strong> Todos los datos en tránsito están cifrados mediante Seguridad de la Capa de Transporte (TLS)
            estándar, y los datos en reposo están asegurados mediante cifrado AES-256.
          </li>
        </ul>
      </>
    ),
  },
  {
    title: '6. Datos de Salud / Categoría Especial',
    content: (
      <p>
        Dado que nuestra plataforma está orientada a clínicas dentales, es posible que se procesen datos que
        se consideran "categoría especial" bajo la LOPDP, como información relacionada con la salud (ej. nombre del paciente,
        motivo de la cita o historial de citas). El tratamiento de estos datos cuenta con protección reforzada
        (Art. 26) y requiere tu consentimiento explícito. Garantizamos que esta información se utiliza única y
        exclusivamente para la gestión y recordatorio de citas y no se comparte con terceros con fines comerciales.
      </p>
    ),
  },
  {
    title: '7. Divulgación de Datos y Autoridades Públicas',
    content: (
      <>
        <p>
          Ruray Digital aplica un riguroso proceso de evaluación con respecto a las solicitudes de las
          autoridades públicas o entidades gubernamentales:
        </p>
        <ul>
          <li>
            Requerimos una revisión exhaustiva y obligatoria de la legalidad absoluta de cualquier solicitud
            de datos bajo la jurisdicción competente.
          </li>
          <li>
            Nos adherimos estrictamente a una política de minimización de datos, asegurando que si una divulgación
            legal es obligatoria, solo se compartirá la información mínima legalmente requerida.
          </li>
        </ul>
      </>
    ),
  },
  {
    title: '8. Derechos del Titular (Derechos ARCO+)',
    content: (
      <>
        <p>
          En cumplimiento con la LOPDP, los clientes y sus usuarios finales mantienen el control total sobre
          sus datos personales. Como titular, tienes derecho a ejercer tus derechos ARCO+:
        </p>
        <ul>
          <li><strong>Acceso:</strong> Solicitar conocer qué datos personales tuyos tenemos y cómo los tratamos.</li>
          <li><strong>Rectificación:</strong> Solicitar la corrección de tus datos si son inexactos o están incompletos.</li>
          <li><strong>Cancelación/Eliminación:</strong> Solicitar la eliminación total y permanente de tus datos de nuestros servidores.</li>
          <li><strong>Oposición:</strong> Oponerte al tratamiento de tus datos para fines específicos.</li>
          <li><strong>Portabilidad:</strong> Recibir tus datos personales en un formato estructurado y transferirlos a otro responsable.</li>
        </ul>
        <p style={{ marginTop: '0.75rem' }}>
          Para ejercer cualquiera de estos derechos, debes enviar una solicitud escrita a nuestro canal dedicado: {' '}
          <a href="mailto:support@ruraydigital.com" style={{ color: '#00e5d1' }}>support@ruraydigital.com</a>.
          Responderemos a tu solicitud en un plazo máximo de quince (15) días calendario.
        </p>
        <p style={{ marginTop: '0.75rem' }}>
          Si una empresa desconecta su activo de Meta/WhatsApp a través de la interfaz de nuestra plataforma, los
          tokens de autorización locales se revocan e invalidan de inmediato.
        </p>
      </>
    ),
  },
  {
    title: '9. Delegado de Protección de Datos (DPO)',
    content: (
      <p>
        Actualmente no contamos con un Delegado de Protección de Datos (DPO) por no alcanzar el umbral de
        tratamiento a gran escala exigido por la normativa. Se designará uno cuando corresponda legalmente.
      </p>
    ),
  },
  {
    title: '10. Información de Contacto',
    content: (
      <>
        <p>
          Para cualquier consulta, solicitudes de eliminación de datos o preguntas sobre esta
          Política de Privacidad, por favor contacta al responsable del tratamiento:
        </p>
        <ul>
          <li><strong>Entidad Responsable:</strong> Ruray Digital</li>
          <li><strong>País de Operación:</strong> Ecuador</li>
          <li>
            <strong>Correo de Contacto:</strong>{' '}
            <a href="mailto:support@ruraydigital.com" style={{ color: '#00e5d1' }}>
              support@ruraydigital.com
            </a>
          </li>
        </ul>
      </>
    ),
  },
];

const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <style>{`
        .pp-root {
          min-height: 100vh;
          background: #000;
          color: #fff;
          font-family: var(--font-body);
          padding: 0;
        }
        .pp-header {
          background: linear-gradient(135deg, rgba(0,229,209,0.08) 0%, rgba(139,92,246,0.08) 100%);
          border-bottom: 1px solid rgba(255,255,255,0.08);
          padding: 3rem 1.5rem 2.5rem;
          text-align: center;
        }
        .pp-logo {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          margin-bottom: 2rem;
          text-decoration: none;
          color: inherit;
        }
        .pp-logo-dot {
          width: 28px;
          height: 28px;
          border-radius: 8px;
          background: linear-gradient(135deg, #00e5d1, #8b5cf6);
        }
        .pp-logo-text {
          font-family: var(--font-heading);
          font-size: 1.2rem;
          font-weight: 700;
          background: linear-gradient(to right, #00e5d1, #8b5cf6);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .pp-title {
          font-family: var(--font-heading);
          font-size: clamp(1.8rem, 5vw, 2.8rem);
          font-weight: 800;
          background: linear-gradient(to right, #00e5d1, #8b5cf6);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 0.75rem;
        }
        .pp-updated {
          color: #9ca3af;
          font-size: 0.9rem;
        }
        .pp-body {
          max-width: 860px;
          margin: 0 auto;
          padding: 3rem 1.5rem 5rem;
        }
        .pp-intro {
          color: #d1d5db;
          line-height: 1.75;
          margin-bottom: 2.5rem;
          font-size: 1rem;
          padding: 1.5rem;
          background: rgba(255,255,255,0.03);
          border: 1px solid rgba(255,255,255,0.08);
          border-radius: 12px;
        }
        .pp-section {
          margin-bottom: 2.5rem;
          padding: 1.75rem;
          background: rgba(255,255,255,0.02);
          border: 1px solid rgba(255,255,255,0.06);
          border-radius: 16px;
          transition: border-color 0.2s;
        }
        .pp-section:hover {
          border-color: rgba(0,229,209,0.2);
        }
        .pp-section h2 {
          font-family: var(--font-heading);
          font-size: 1.15rem;
          font-weight: 700;
          color: #fff;
          margin-bottom: 1rem;
          padding-bottom: 0.75rem;
          border-bottom: 1px solid rgba(255,255,255,0.06);
        }
        .pp-section p {
          color: #d1d5db;
          line-height: 1.75;
          margin-bottom: 0.75rem;
          font-size: 0.95rem;
        }
        .pp-section p:last-child { margin-bottom: 0; }
        .pp-section ul {
          padding-left: 1.5rem;
          margin: 0.75rem 0;
          display: flex;
          flex-direction: column;
          gap: 0.6rem;
        }
        .pp-section li {
          color: #d1d5db;
          line-height: 1.7;
          font-size: 0.95rem;
        }
        .pp-section strong {
          color: #fff;
        }
        .disclosure {
          margin-top: 1rem !important;
          padding: 1rem;
          background: rgba(0,229,209,0.05);
          border: 1px solid rgba(0,229,209,0.15);
          border-radius: 8px;
          color: #e5e7eb !important;
        }
        .pp-footer {
          text-align: center;
          padding: 2rem 1.5rem;
          border-top: 1px solid rgba(255,255,255,0.06);
          color: #6b7280;
          font-size: 0.85rem;
        }
        .pp-footer a {
          color: #00e5d1;
          text-decoration: none;
        }
        .pp-footer a:hover { text-decoration: underline; }
      `}</style>

      <div className="pp-root">
        <header className="pp-header">
          <a href="/" className="pp-logo">
            <div className="pp-logo-dot" />
            <span className="pp-logo-text">Ruray Digital</span>
          </a>
          <h1 className="pp-title">Política de Privacidad</h1>
          <p className="pp-updated">Última actualización: 13 de agosto de 2026</p>
        </header>

        <main className="pp-body">
          <div className="pp-intro">
            En Ruray Digital, accesible desde nuestra plataforma y sitio web oficial, una de nuestras
            principales prioridades es la privacidad de nuestros usuarios y sus clientes. Esta Política de
            Privacidad describe cómo Ruray Digital recopila, utiliza, almacena y protege los datos
            personales, particularmente en relación con nuestra integración con Meta Platforms, Inc. y
            la API de WhatsApp Business.
            <br /><br />
            El tratamiento de tus datos personales se rige por la Ley Orgánica de Protección de Datos Personales
            (LOPDP) del Ecuador. Si consideras que tus derechos no fueron atendidos correctamente, puedes presentar
            un reclamo ante la Superintendencia de Protección de Datos Personales (SPDP) — <a href="https://spdp.gob.ec" target="_blank" rel="noreferrer" style={{ color: '#00e5d1' }}>spdp.gob.ec</a>.
            <br /><br />
            Si tienes preguntas adicionales o requieres más información sobre nuestra Política de Privacidad,
            no dudes en contactarnos en{' '}
            <a href="mailto:support@ruraydigital.com" style={{ color: '#00e5d1' }}>
              support@ruraydigital.com
            </a>.
          </div>

          {sections.map((s) => (
            <section key={s.title} className="pp-section">
              <h2>{s.title}</h2>
              {s.content}
            </section>
          ))}
        </main>

        <footer className="pp-footer">
          <p>© {new Date().getFullYear()} Ruray Digital — Ecuador</p>
          <p style={{ marginTop: '0.5rem' }}>
            <a href="/">← Volver a ruraydigital.com</a>
          </p>
        </footer>
      </div>
    </>
  );
};

export default PrivacyPolicy;
